import BannerFieldModel from './BannerField';
import BranchComboBoxField from './BranchComboBoxField';
import CheckboxField from './CheckboxField';
import ConditionallyDependentField from './ConditionalDependentField';
import ContentField from './ContentField';
import CountriesComboBoxField from './CountriesComboBoxField';
import DatePickerFieldModel from './DatePickerFieldModel';
import DistrictComboBoxFieldModel from './DistrictComboBoxField';
import FileUploaderFieldModel from './FileUploaderField';
import FormFieldGroup from './FormFieldGroupField';
import FormVisitDateTimeField from './FormVisitDateTime';
import InformedOTPFieldModel from './InformedOTPfield';
import InstituteFormField from './InstituteFormField';
import MultipleSelectFieldModel from './MultipleSelectField';
import MultiSelectCheckboxGroupField from './MultiSelectCheckboxGroupField';
import ParamsField from './ParamsField';
import PhoneNumberField from './PhoneNumberField';
import RadioGroupFormField from './RadioGroupFormField';
import SelectField from './SelectField';
import SlotSelectionField from './SlotSelectionField';
import StatesComboBoxField from './StatesComboBoxField';
import TextAreaField from './TextareaField';
import TextFormField from './TextFormField';

export interface FieldPattern<T> {
  TextFormField: (fieldInfo: TextFormField) => T;
  SelectField: (fieldInfo: SelectField) => T;
  StatesComboBoxField: (FieldInfo: StatesComboBoxField) => T;
  DistrictComboBoxField: (FieldInfo: DistrictComboBoxFieldModel) => T;
  CheckBoxField: (fieldInfo: CheckboxField) => T;
  ParamsField: (FieldInfo: ParamsField) => T;
  InstituteField: (FieldInfo: InstituteFormField) => T;
  RadioGroupFormField: (FieldInfo: RadioGroupFormField) => T;
  InformedOTPField: (FieldInfo: InformedOTPFieldModel) => T;
  PhoneNumberField: (FieldInfo: PhoneNumberField) => T;
  SlotSelectionField: (FieldInfo: SlotSelectionField) => T;
  ConditionallyDependentField: (FieldInfo: ConditionallyDependentField) => T;
  MultiSelectCheckboxGroupField: (
    FieldInfo: MultiSelectCheckboxGroupField
  ) => T;
  BranchComboBoxField: (FieldInfo: BranchComboBoxField) => T;
  BannerField: (FieldInfo: BannerFieldModel) => T;
  MultipleSelectField: (FieldInfo: MultipleSelectFieldModel) => T;
  ContentField: (FieldInfo: ContentField) => T;
  FormFieldGroup: (FieldInfo: FormFieldGroup) => T;
  FileUploaderField: (FieldInfo: FileUploaderFieldModel) => T;
  DatePickerField: (fieldInfo: DatePickerFieldModel) => T;
  CountriesComboBoxField: (fieldInfo: CountriesComboBoxField) => T;
  TextAreaField: (FieldInfo: TextAreaField) => T;
  FormVisitDateTimeField: (FieldInfo: FormVisitDateTimeField) => T;
}

export interface FieldMatcher {
  match<T>(p: FieldPattern<T>): T;
}

export abstract class Field implements FieldMatcher {
  abstract match<T>(p: FieldPattern<T>): T;
}
